import {
    FETCH_NEWS_FEED_ACTIVITIES_START,
    FETCH_NEWS_FEED_ACTIVITIES_SUCCESS,
    FETCH_NEWS_FEED_ACTIVITIES_FAIL,
    UPDATE_NEWS_FEED_ACTIVITY_PRIVACY_START,
    UPDATE_NEWS_FEED_ACTIVITY_PRIVACY_SUCCESS,
    UPDATE_NEWS_FEED_ACTIVITY_PRIVACY_FAIL,
    RESET_NEWS_FEED_ACTIVITIES,
    UPDATE_NEWS_FEED_ACTIVITY_COMMENT_COUNT,
    UPDATE_NEWS_FEED_ERROR_STATE,
    FILTER_NEWS_FEED_ACTIVITIES,
    // Conversation Likes
    ADD_NEWS_FEED_CONVERSATION_LIKE_START,
    ADD_NEWS_FEED_CONVERSATION_LIKE_SUCCESS,
    ADD_NEWS_FEED_CONVERSATION_LIKE_FAIL,
    REMOVE_NEWS_FEED_CONVERSATION_LIKE_START,
    REMOVE_NEWS_FEED_CONVERSATION_LIKE_SUCCESS,
    REMOVE_NEWS_FEED_CONVERSATION_LIKE_FAIL,
    UPDATE_NEWS_FEED_ACTIVITY_LIKES,
    // reporter
    NEWS_FEED_OPEN_REPORT_PHOTO_DIALOG,
    NEWS_FEED_CLOSE_REPORT_PHOTO_DIALOG,
    NEWS_FEED_SUMBIT_REPORT_PHOTO,
    NEWS_FEED_SUMBIT_REPORT_PHOTO_DONE,
    NEWS_FEED_REMOVE_IMAGE_FROM_FEED
} from 'actions/ActionTypes';

const INITIAL_STATE = {
    activityList: [],
    activitiesFetching: false,
    activitiesFetchingSuccess: false,
    activitiesFetchingFail: false,
    activityPrivacyUpdating: { activityId: null, updating: false },
    activityPrivacyUpdateSuccess: false,
    activityPrivacyUpdateFail: false,
    hasError: false,
    daysLimit: null,
    nextCursor: null,
    conversationLikeUpdating: {},
    reportDialog: {
        open: false,
        submitting: false,
        error: false,
        reviewStatus: null,
        activityId: null,
        imageUuid: null
    }
};

// privacy key and id mapping
const activityPrivacyTypeId = {
    public: 1,
    private: 2,
    subscribers: 3,
    groups: 4
};

const activitiesFetching = (state) => ({
    ...state,
    activitiesFetching: true
});

const activitiesFetchFinished = (isSuccess) => (state, action) => {
    let { activityList, daysLimit, nextCursor } = state;

    if (isSuccess) {
        const { data } = action;
        // reset will be true when new filter is applied
        const reset = activityList.length > 0 && data.filter.cursor === null;
        activityList = reset ? data.activityList : activityList.concat(data.activityList);
        daysLimit = data.daysLimit;
        nextCursor = data.filter.nextCursor || null;
    }

    return {
        ...state,
        activityList,
        daysLimit,
        nextCursor,
        activitiesFetching: false,
        activitiesFetchingSuccess: isSuccess,
        activitiesFetchingFail: !isSuccess
    };
};

const updateNewsfeedActivityCommentCount = (state, action) => {
    const { addCount, activityId } = action.payload;
    return {
        ...state,
        activityList: state.activityList.map((activity) => {
            if (activity.activityId === activityId) {
                activity.numberOfActivityComments = addCount
                    ? activity.numberOfActivityComments + 1
                    : activity.numberOfActivityComments - 1;
            }
            return activity;
        })
    };
};

// activity privacy
const activityPrivacyUpdating = (state, action) => ({
    ...state,
    activityPrivacyUpdating: {
        activityId: action.activityId,
        updating: true
    }
});
const activityPrivacyUpdateFinished = (isSuccess) => (state, action) => {
    let newActivityList;
    if (isSuccess) {
        const { accessControlRuleDTO, activityId } = action;
        const { typeKey } = accessControlRuleDTO;
        newActivityList = state.activityList.map((activity) => {
            if (activity.activityId === activityId) {
                activity.privacy = {
                    typeKey,
                    typeId: activityPrivacyTypeId[typeKey]
                };
            }
            return activity;
        });
    }

    return {
        ...state,
        activityList: isSuccess ? newActivityList : state.activityList,
        activityPrivacyUpdating: {
            activityId: null,
            updating: false
        },
        activityPrivacyUpdateSuccess: isSuccess,
        activityPrivacyUpdateFail: !isSuccess
    };
};

const updateNewsfeedErrorState = (state, { hasError }) => {
    return {
        ...state,
        hasError
    };
};

const filterNewsFeedActivities = (state, { displayName }) => {
    const firstHitIndex = state.activityList.findIndex((activity) => activity.ownerDisplayName === displayName);
    // We're going to animate activities that are after the first filtered-out target
    return {
        ...state,
        activityList: state.activityList
            .filter((activity) => activity.ownerDisplayName !== displayName)
            .map((activity, index) => ({
                ...activity,
                shouldAnimate: index >= firstHitIndex
            }))
    };
};

const updateNewsFeedConversationLikeStart = (state, { activityId }) => ({
    ...state,
    conversationLikeUpdating: {
        ...state.conversationLikeUpdating,
        [activityId]: true
    }
});

const addNewsFeedConversationLikeFinished = (isSuccess) => (state, { activityId, likerInfo, conversationLikeDto }) => {
    if (isSuccess) {
        const { profileImageUrlSmall, fullName, displayName, profileId } = likerInfo;
        return {
            ...state,
            activityList: state.activityList.map((activity) => {
                if (activity.activityId === activityId) {
                    return {
                        ...activity,
                        likedByUser: true,
                        numberOfActivityLikes: (activity.numberOfActivityLikes || 0) + 1,
                        activityLikeDisplayNames: activity.activityLikeDisplayNames
                            ? [...activity.activityLikeDisplayNames, displayName]
                            : [displayName],
                        activityLikeFullNames: activity.activityLikeFullNames
                            ? [...activity.activityLikeFullNames, fullName]
                            : [fullName],
                        activityLikeProfileImageUrls: activity.activityLikeProfileImageUrls
                            ? [...activity.activityLikeProfileImageUrls, profileImageUrlSmall]
                            : [profileImageUrlSmall],
                        activityLikeUserIds: activity.activityLikeUserIds
                            ? [...activity.activityLikeUserIds, profileId]
                            : [profileId],
                        conversationUuid: activity.conversationUuid || conversationLikeDto.conversationUuid
                    };
                }
                return activity;
            }),
            conversationLikeUpdating: {
                ...state.conversationLikeUpdating,
                [activityId]: false
            }
        };
    } else {
        return {
            ...state,
            conversationLikeUpdating: {
                ...state.conversationLikeUpdating,
                [activityId]: false
            }
        };
    }
};

const removeNewsFeedConversationLikeFinished = (isSuccess) => (state, { activityId, likerInfo }) => {
    if (isSuccess) {
        const { profileImageUrlSmall, fullName, displayName, profileId } = likerInfo;
        return {
            ...state,
            activityList: state.activityList.map((activity) => {
                if (activity.activityId === activityId) {
                    return {
                        ...activity,
                        likedByUser: false,
                        numberOfActivityLikes: activity.numberOfActivityLikes - 1,
                        activityLikeDisplayNames: activity.activityLikeDisplayNames.filter(
                            (likeDisplayName) => likeDisplayName !== displayName
                        ),
                        activityLikeFullNames: activity.activityLikeFullNames.filter(
                            (likeFullName) => likeFullName !== fullName
                        ),
                        activityLikeProfileImageUrls: activity.activityLikeProfileImageUrls.filter(
                            (imageUrl) => imageUrl !== profileImageUrlSmall
                        ),
                        activityLikeUserIds: activity.activityLikeUserIds.filter((item) => item !== profileId)
                    };
                }
                return activity;
            }),
            conversationLikeUpdating: {
                ...state.conversationLikeUpdating,
                [activityId]: false
            }
        };
    } else {
        return {
            ...state,
            conversationLikeUpdating: {
                ...state.conversationLikeUpdating,
                [activityId]: false
            }
        };
    }
};

const updateNewsFeedActivityLikes = (state, { data }) => ({
    ...state,
    activityList: state.activityList.map((activity) => {
        if (activity.activityId === data.activityId) {
            const {
                likedByUser,
                numberOfActivityLikes,
                activityLikeDisplayNames,
                activityLikeFullNames,
                activityLikeProfileImageUrls
            } = data;
            return {
                ...activity,
                likedByUser,
                numberOfActivityLikes,
                activityLikeDisplayNames,
                activityLikeFullNames,
                activityLikeProfileImageUrls
            };
        }
        return activity;
    })
});

const openReportPhotoDialog = (state, action) => {
    return {
        ...state,
        reportDialog: {
            open: true,
            submitting: false,
            error: false,
            reviewStatus: null,
            activityId: action.activityId,
            imageUuid: action.imageUuid
        }
    };
};

const closeReportPhotoDialog = (state) => {
    return {
        ...state,
        reportDialog: {
            ...state.reportDialog,
            open: false
        }
    };
};

const submitReportPhoto = (state, action) => {
    return {
        ...state,
        reportDialog: {
            ...state.reportDialog,
            submitting: true
        }
    };
};

const submitReportPhotoDone = (state, action) => {
    if (action.error) {
        return {
            ...state,
            reportDialog: {
                ...state.reportDialog,
                error: true,
                submitting: false
            }
        };
    }
    return {
        ...state,
        reportDialog: {
            ...state.reportDialog,
            error: false,
            submitting: false,
            reviewStatus: action.reviewStatus
        }
    };
};

const removePhotoFromFeed = (state, action) => {
    let newActivityList = state.activityList || [];
    const feedIndex = newActivityList.findIndex((item) => item.activityId === action.activityId);
    if (feedIndex < 0 || !newActivityList[feedIndex].activityImages) {
        return state;
    }
    const newFeed = {
        ...newActivityList[feedIndex]
    };
    const newActivityImages = newFeed.activityImages.filter((item) => item.imageId !== action.imageUuid);
    newActivityList = newActivityList.slice();
    newFeed.activityImages = newActivityImages;
    newActivityList.splice(feedIndex, 1, newFeed);
    return {
        ...state,
        activityList: newActivityList
    };
};

const resetActivities = () => {
    return INITIAL_STATE;
};

const handlers = {
    [FETCH_NEWS_FEED_ACTIVITIES_START]: activitiesFetching,
    [FETCH_NEWS_FEED_ACTIVITIES_SUCCESS]: activitiesFetchFinished(true),
    [FETCH_NEWS_FEED_ACTIVITIES_FAIL]: activitiesFetchFinished(false),
    [RESET_NEWS_FEED_ACTIVITIES]: resetActivities,
    [UPDATE_NEWS_FEED_ACTIVITY_COMMENT_COUNT]: updateNewsfeedActivityCommentCount,
    [UPDATE_NEWS_FEED_ACTIVITY_PRIVACY_START]: activityPrivacyUpdating,
    [UPDATE_NEWS_FEED_ACTIVITY_PRIVACY_SUCCESS]: activityPrivacyUpdateFinished(true),
    [UPDATE_NEWS_FEED_ACTIVITY_PRIVACY_FAIL]: activityPrivacyUpdateFinished(false),
    [UPDATE_NEWS_FEED_ERROR_STATE]: updateNewsfeedErrorState,
    [FILTER_NEWS_FEED_ACTIVITIES]: filterNewsFeedActivities,
    [ADD_NEWS_FEED_CONVERSATION_LIKE_START]: updateNewsFeedConversationLikeStart,
    [ADD_NEWS_FEED_CONVERSATION_LIKE_SUCCESS]: addNewsFeedConversationLikeFinished(true),
    [ADD_NEWS_FEED_CONVERSATION_LIKE_FAIL]: addNewsFeedConversationLikeFinished(false),
    [REMOVE_NEWS_FEED_CONVERSATION_LIKE_START]: updateNewsFeedConversationLikeStart,
    [REMOVE_NEWS_FEED_CONVERSATION_LIKE_SUCCESS]: removeNewsFeedConversationLikeFinished(true),
    [REMOVE_NEWS_FEED_CONVERSATION_LIKE_FAIL]: removeNewsFeedConversationLikeFinished(false),
    [UPDATE_NEWS_FEED_ACTIVITY_LIKES]: updateNewsFeedActivityLikes,
    [NEWS_FEED_OPEN_REPORT_PHOTO_DIALOG]: openReportPhotoDialog,
    [NEWS_FEED_CLOSE_REPORT_PHOTO_DIALOG]: closeReportPhotoDialog,
    [NEWS_FEED_SUMBIT_REPORT_PHOTO]: submitReportPhoto,
    [NEWS_FEED_SUMBIT_REPORT_PHOTO_DONE]: submitReportPhotoDone,
    [NEWS_FEED_REMOVE_IMAGE_FROM_FEED]: removePhotoFromFeed
};

export const getActivitiesFetching = (state) => state.newsFeedActivities.activitiesFetching;
export const getActivityList = (state) => state.newsFeedActivities.activityList;
export const getDaysLimit = (state) => state.newsFeedActivities.daysLimit;
export const getPrivacyUpdating = (state) => state.newsFeedActivities.activityPrivacyUpdating;
export const getHasError = (state) => state.newsFeedActivities.hasError;
export const getHasMore = (state) => state.newsFeedActivities.nextCursor !== null;
export const getReportDialogState = (state) => state.newsFeedActivities.reportDialog;

export default function newsFeedActivities(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
